import React from "react";

interface PictureProps {
    size?: "S" | "M" | "L" | "FULL";
    src: string;
    alt?: string;
    customSize?: string;
    isFullBrightness?: boolean
}

/**
 * A responsive picture component with predefined or custom sizes.
 * @param {string} size - Preset sizes: S (128px), M (256px), L (512px), FULL (1920px).
 * @param {string} customSize - Custom Tailwind classes for width/height, e.g., "w-[50px] h-[50px] or Additional classes for styling".
 */
export default function Picture({
    size = "M",
    src,
    alt = "Image",
    customSize,
    isFullBrightness = false
}: PictureProps) {
    const sizeClasses: Record<"S" | "M" | "L" | "FULL", string> = {
        S: "w-[128px] h-auto",
        M: "w-[256px] h-auto",
        L: "w-[512px] h-auto",
        FULL: "w-full h-auto",
    };

    const imageSize = customSize || sizeClasses[size];

    return (
        <figure className={`${imageSize}`}>
            <img src={src} alt={alt} className={`w-full h-full ${isFullBrightness ? "brightness-0 invert-[1]" : "brightness-100"}`} />
        </figure>
    );
}
